import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';

import cn from 'classnames';
import { Button } from 'components/UtilElements';
import { RootState } from 'redux/reducers';

interface LmsApiAuthProps {
  accessData: SessionData | null;
  redirectUrl: string;
}

const LmsApiAuth: FC<LmsApiAuthProps> = ({ accessData, redirectUrl }) => {
  const authorize = useCallback(async () => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  if (!accessData) return null;

  return (
    <>
      <h2 className='auth__title'>API Authorization</h2>
      <div className='auth__panel'>
        <p className='auth__message'>
          Acadly needs your authorization to take the following actions on your behalf:
        </p>
        <ul className='auth__list'>
          {accessData.context === 'course' ? (
            <>
              <li className='auth__list-item'>Export your course's data from LMS into Acadly</li>
              <li className='auth__list-item'>Export enrolment data from LMS into Acadly</li>
              <li className='auth__list-item'>
                Create custom gradebook columns when you import data from Acadly into your LMS
              </li>
            </>
          ) : (
            <>
              <li className='auth__list-item'>Export courses' data from LMS into Acadly</li>
              <li className='auth__list-item'>Export users' data from LMS into Acadly</li>
            </>
          )}
        </ul>
        <p className='auth__message'>If you agree, we will take you to your LMS's API Authorization Page</p>
        <div className='auth__action-container'>
          <Button type='ghost' selector={cn('btn-primary', 'auth__action')} onRipple={() => authorize()}>
            YES, I AGREE
          </Button>
        </div>
        <p className='auth__note'>For the LMS plugin integration to work, API Authorization is essential</p>
      </div>
    </>
  );
};

const mapStateToProps = ({ getAccess }: RootState) => {
  return { accessData: getAccess };
};

export default connect(mapStateToProps)(LmsApiAuth);
